module.exports = __webpack_public_path__ + "img/avatar-11.4fdcb5f4.png";